export enum AgentProcessingStatus {
  DRAFT = 'draft',
  READY = 'ready',
  IN_PROGRESS = 'inProgress',
  PENDING = 'pending',
  COMPLETED = 'completed',
}

export enum ThreadStatus {
  READ = 'read',
  UNREAD = 'unread',
  COMPLETED = 'completed',
}

export enum ThreadVariant {
  CONVERSATION = 'conversation',
  GUIDED = 'guided',
  SOURCING = 'sourcing',
}
